/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbDocumentType } from './HchbDocumentType';
import {
    HchbDocumentTypeFromJSON,
    HchbDocumentTypeFromJSONTyped,
    HchbDocumentTypeToJSON,
    HchbDocumentTypeToJSONTyped,
} from './HchbDocumentType';

/**
 * 
 * @export
 * @interface HchbUploadDocumentTaskItem
 */
export interface HchbUploadDocumentTaskItem {
    /**
     * 
     */
    relationId: string;
    /**
     * 
     */
    relationType: HchbUploadDocumentTaskItemRelationTypeEnum;
    /**
     * 
     */
    fileName: string;
    /**
     * 
     */
    sourceS3Key: string;
    /**
     * 
     */
    hchbDocumentType: HchbDocumentType;
}


/**
 * @export
 */
export const HchbUploadDocumentTaskItemRelationTypeEnum = {
    ScreenerDocument: 'screener_document',
    ScreenerAdditionalDocument: 'screener_additional_document',
    ScreenerGeneratedDocument: 'screener_generated_document',
} as const;
export type HchbUploadDocumentTaskItemRelationTypeEnum = typeof HchbUploadDocumentTaskItemRelationTypeEnum[keyof typeof HchbUploadDocumentTaskItemRelationTypeEnum];


/**
 * Check if a given object implements the HchbUploadDocumentTaskItem interface.
 */
export function instanceOfHchbUploadDocumentTaskItem(value: object): value is HchbUploadDocumentTaskItem {
    if (!('relationId' in value) || value['relationId'] === undefined) return false;
    if (!('relationType' in value) || value['relationType'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('sourceS3Key' in value) || value['sourceS3Key'] === undefined) return false;
    if (!('hchbDocumentType' in value) || value['hchbDocumentType'] === undefined) return false;
    return true;
}

export function HchbUploadDocumentTaskItemFromJSON(json: any): HchbUploadDocumentTaskItem {
    return HchbUploadDocumentTaskItemFromJSONTyped(json, false);
}

export function HchbUploadDocumentTaskItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbUploadDocumentTaskItem {
    if (json == null) {
        return json;
    }
    return {
        
        'relationId': json['relationId'],
        'relationType': json['relationType'],
        'fileName': json['fileName'],
        'sourceS3Key': json['sourceS3Key'],
        'hchbDocumentType': HchbDocumentTypeFromJSON(json['hchbDocumentType']),
    };
}

export function HchbUploadDocumentTaskItemToJSON(json: any): HchbUploadDocumentTaskItem {
    return HchbUploadDocumentTaskItemToJSONTyped(json, false);
}

export function HchbUploadDocumentTaskItemToJSONTyped(value?: HchbUploadDocumentTaskItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationId': value['relationId'],
        'relationType': value['relationType'],
        'fileName': value['fileName'],
        'sourceS3Key': value['sourceS3Key'],
        'hchbDocumentType': HchbDocumentTypeToJSON(value['hchbDocumentType']),
    };
}

